type Gender = {
  ID: string
  name: string
}

// Hoisted to module scope so the returned value keeps a stable identity across
// calls. Its sibling query hooks get that for free from react-query's cache;
// rebuilding these literals per call would silently invalidate any consumer's
// useMemo that depends on `data`.
const GENDERS: Gender[] = [
  {
    ID: '1',
    name: 'Male',
  },
  {
    ID: '0',
    name: 'Female',
  },
]

const RESULT = {data: GENDERS, status: 'success'} as const

type UseGenders = () => {data: Gender[]; status: 'success'}
export const useGenders: UseGenders = () => RESULT
